import type { ExcPlaidV1ProcessorTokenKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const PLAID_PROCESSOR_TOKEN_BASE_PATH = getResolvedPath('/clearing/vendor/plaid/processor-token');

export const getPlaidProcessorTokenPath: EntityPathBuilder<ExcPlaidV1ProcessorTokenKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PLAID_PROCESSOR_TOKEN_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.processorTokenId) {
        return undefined;
      }

      return getResolvedPath(`${PLAID_PROCESSOR_TOKEN_BASE_PATH}/$processorTokenId`, context.keys);
    }
  }
};

export function getPlaidProcessorTokenDetailPath(processorTokenId: string | undefined) {
  if (!processorTokenId) {
    return undefined;
  }

  return getPlaidProcessorTokenPath({ kind: 'detail', keys: { processorTokenId } });
}
